import { memo, useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface RefreshAlertDialogProps {
  isOpen: boolean;
  title: string;
  description: string;
}

const RefreshAlertDialog = ({ isOpen, title, description }: RefreshAlertDialogProps) => {
  const { t } = useTranslation('common_navbar', { useSuspense: false });
  const cancelRef = useRef<HTMLButtonElement>(null);
  const onClose = () => window.location.reload();

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize='lg' fontWeight='bold'>
            {title}
          </AlertDialogHeader>

          <AlertDialogBody>
            <Text as='span'>{description}</Text>
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} colorScheme='action' onClick={onClose} ml={3}>
              {t('modals.refresh.refresh-button')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default memo(RefreshAlertDialog);
